import { POS_STORE_ADMIN_ROLE_NAMES } from '../constants/posConst';

/**
 * Whether a role is the club's STORE ADMIN role.
 *
 * True when the administrator ticked "Store admin" on it, OR when it is simply
 * named "Admin" (see POS_STORE_ADMIN_ROLE_NAMES) — clubs set up before the
 * checkbox existed already have an "Admin" role, and it should behave as one
 * without anyone having to go back and tick a box.
 *
 * Its own module, importing constants only, so both posClientUtil and posUtil
 * can use it without importing each other.
 *
 * @param {{name?: string, isAdmin?: boolean}|null|undefined} role
 * @returns {boolean}
 */
export const isStoreAdminRole = (role) => Boolean(role) && (
  role.isAdmin === true
  || POS_STORE_ADMIN_ROLE_NAMES.includes(String(role.name || '').trim().toLowerCase())
);

export default isStoreAdminRole;
